import { H2 } from "@blueprintjs/core";
import { TeamMemberCard } from "components";
import { setCurrentRoute, setPreviousRoute } from "controllers/common/action";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { constructPath, findRoute, routes } from "routes";
import { Analytics } from "utils/analytics";
import route from "./route";
import "./Team.scss";

export default function Team() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setCurrentRoute(route));
    Analytics.getInstance().pageview(constructPath(findRoute(routes, route.id)));
    return () => dispatch(setPreviousRoute(route));
  });
  return (
    <section id="team">
      <H2>Meet the Team</H2>
      <div className="team-members">
        <TeamMemberCard
          link="https://www.pnnl.gov/people/di-wu"
          photo="https://pnnlcreative.getbynder.com/m/9998fa0ef4dd6e28/Digital_Newsletter-Wu-Di.jpg"
          name="Di Wu"
          role={`Team Lead & Former PI (2017-2021)`}
          description=""
        />
        <TeamMemberCard
          link="https://www.pnnl.gov/people/dexin-wang"
          photo="https://pnnlcreative.getbynder.com/m/3ee595ddf5f94e2d/Digital_Newsletter-Wang_Dexin-1.jpg"
          name="Dexin Wang"
          role="Principal Investigator"
        />
        {/* </div>
      <div className="team-members"> */}
        <TeamMemberCard
          link="https://www.pnnl.gov/people/xu-ma"
          photo="https://pnnlcreative.getbynder.com/m/c4e36c79d4c129e/Digital_Newsletter-Ma_Xu-2.jpg"
          name="Xu Ma"
          role={"Modeling & Optimization"}
        />

        <TeamMemberCard
          link="https://www.pnnl.gov/people/bowen-huang"
          photo="https://pnnlcreative.getbynder.com/m/4904b3930744c672/Digital_Newsletter-Huang_Bowen-2.jpg"
          name="Bowen Huang"
          role={"Modeling & Optimization"}
        />

        <TeamMemberCard
          link="https://www.pnnl.gov/people/alasdair-crawford"
          photo="https://www.pnnl.gov/sites/default/files/styles/portrait/public/media/image/Alasdair%20Crawford.jpg?h=ff2033e8&itok=3IJZVo0N"
          name="Alasdair Crawford"
          role={"Modeling & Optimization"}
          description=""
        />
        <TeamMemberCard
          link="https://www.pnnl.gov/people/vish-viswanathan"
          photo="https://pnnlcreative.getbynder.com/m/73ab655e1656db46/Digital_Newsletter-Viswanathan_Vilayanur-4.jpg"
          name="Vish Viswanathan"
          role={"Modeling & Optimization"}
          description=""
        />
        <TeamMemberCard
          link="https://www.pnnl.gov/people/avijit-das"
          photo="https://pnnlcreative.getbynder.com/m/7ce87a5e686aa1b1/Digital_Newsletter-Das_Avijit-2.jpg"
          name="Avijit Das"
          role={"Modeling & Optimization"}
          description=""
        />

        <TeamMemberCard
          link="https://www.pnnl.gov/people/thiagarajan-ramachandran"
          photo="https://pnnlcreative.getbynder.com/m/049409797b130f43/Digital_Newsletter-Ramachandran-Thiagarajan.jpg"
          name="Thiagarajan Ramachandran"
          role="Modeling & Optimization"
        />

        <TeamMemberCard
          link="https://www.pnnl.gov/people/tao-fu"
          photo="https://pnnlcreative.getbynder.com/m/4648769094987f07/Digital_Newsletter-Fu-Tao.jpg"
          name="Tao Fu"
          role={`Data Analytics & Financial Analysis`}
        />

        <TeamMemberCard
          link="https://www.pnnl.gov/people/jason-hou"
          photo="images/persons/Jason_Hou.png"
          name="Jason Hou"
          role={`Data Analytics & Financial Analysis`}
        />

        <TeamMemberCard
          link="https://www.pnnl.gov/people/paul-tran"
          photo="images/persons/Paul_Tran.png"
          name="Paul Tran"
          role="UX Design"
        />
        <TeamMemberCard
          photo="images/persons/Rachel_Long.jpg"
          name="Rachel Long"
          role="UX Design"
        />
        <TeamMemberCard
          photo="images/persons/Zimo_Wang.png"
          name="Zimo Wang"
          role="UX Design"
        />
        <TeamMemberCard
          photo="images/persons/person.png"
          name="Justin Wells-Driscoll"
          role="UX Design"
        />

        <TeamMemberCard
          link={`https://www.pnnl.gov/contacts/search.asp?sname=Bleeker%2C+Amelia&submit=Search`}
          photo="images/persons/Bleeker_Amelia.jpg"
          name="Amelia Bleeker"
          role="Software Development"
        />
        <TeamMemberCard
          photo="images/persons/Shane_Liu.jpg"
          name="Shane Liu"
          role="Software Development"
        />
        <TeamMemberCard
          link="https://www.pnnl.gov/people/yanyan-zhu"
          photo="images/persons/Zhu_Yanyan.jpg"
          name="Yanyan Zhu"
          role="Software Development"
          description=""
        />
        <TeamMemberCard
          link="https://www.pnnl.gov/people/eric-engel"
          photo="https://pnnlcreative.getbynder.com/m/6654bce74f6c327b/Digital_Newsletter-Engel_Eric-2.jpg"
          name="Eric Engel"
          role="Software Development"
          description=""
        />
        <TeamMemberCard
          link="https://energyenvironment.pnnl.gov/staff/staff_info.asp?staff_num=4106"
          photo="images/persons/person.png"
          name="Avinash Joshi"
          role="Software Development"
          description=""
        />
      </div>
      <H2>Former Team Members</H2>
      <div className="team-members">
        <TeamMemberCard
          photo="https://www.pnnl.gov/sites/default/files/styles/hero_canvas/public/media/image/Portrait_Fan_Xiaoyuan%28PI%29%20%281%29_0.jpg?itok=YDzmxelV"
          name="Xiaoyuan Fan"
          role={"Modeling & Optimization"}
          description=""
        />

        <TeamMemberCard
          link="https://www.pnnl.gov/people/kaitlyn-he"
          photo="https://www.pnnl.gov/sites/default/files/styles/hero_canvas/public/media/image/Web%20Size-He%2C%20Xinhao%20%28Kaitlyn%29_0.jpg?itok=mpt9ORIV"
          name="Kaitlyn He"
          role="UX Design"
        />

        <TeamMemberCard
          photo="https://pnnlcreative.getbynder.com/m/92e2894c7c2e8363/Digital_Newsletter-Huang-Sen.jpg"
          name="Sen Huang"
          role={"Software Architecture"}
          description=""
        />

        <TeamMemberCard
          link="https://energyenvironment.pnnl.gov/staff/staff_info.asp?staff_num=4906"
          photo="https://pnnlcreative.getbynder.com/m/5af596e2a60bf4da/Digital_Newsletter-She_Buxin-1.jpg"
          name="Buxin She"
          role="Modeling & Optimization"
        />

        <TeamMemberCard
          photo="images/persons/person.png"
          name="April Sun"
          role={`Data Analytics & Financial Analysis`}
          description=""
        />

        <TeamMemberCard
          photo="images/persons/person.png"
          name="Mark Weimar"
          role={`Data Analytics & Financial Analysis`}
        />
      </div>
    </section>
  );
}
